import Layout from "../components/Layout/HomePage/Layout";
import Index from "../components/Layout/Instruction/Index"

export default function InstructionPage(){
    return(
        <Layout>            
            <Index />          
        </Layout>
    )
}